// src/components/Login.tsx
import React, { useEffect, useState } from 'react';
import '../../../components/login/login.css';
import loginBackground from '../../../assets/images/bg.svg'
import logo from '../../../assets/images/logo-icon.png';
import LoginService from '../../../components/login/login-service';
import { Button } from 'primereact/button';
import { useNavigate, useParams } from 'react-router-dom';
import { PublicClientApplication } from "@azure/msal-browser";
import { msalInstance } from '../../../utils/msalConfig';


const Login: React.FC = () => {
  const [email, setEmail] = useState<string>('');
  const [username, setUsername] = useState<string>('');
  const [error, setError] = useState<string | null>(null);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [isReady, setIsReady] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const { param } = useParams();

  useEffect(() => {
    msalInstance.initialize().then(() => setIsReady(true));

  }, []);

  // 1️⃣ Trigger redirect login
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const trimmedEmail = email.trim().toLowerCase();
      localStorage.setItem('login', 'true');
      await msalInstance.loginRedirect({
        scopes: ["User.Read"],
        loginHint: trimmedEmail,
      });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
    }
  };

  // 2️⃣ Handle the redirect result when user comes back
  useEffect(() => {
    (async () => {
      await msalInstance.initialize();
      setIsReady(true);

      try {
        const res = await msalInstance.handleRedirectPromise();
        const login = localStorage.getItem("login");

        if (res && login && login === 'true') {
          const account = res.account;
          if (!account) return;

          const tokenResponse = await msalInstance.acquireTokenSilent({
            scopes: ["User.Read"],
            account,
          });

          const country = account.idTokenClaims?.tenant_ctry || "MY";

          const userData = await fetch("https://graph.microsoft.com/v1.0/me", {
            headers: { Authorization: `Bearer ${tokenResponse.accessToken}` },
          }).then((res) => res.json());

          const microsoftEmail = (userData.mail || userData.userPrincipalName || "").toLowerCase();
          if (microsoftEmail !== (account.username || "").toLowerCase()) {
            setError("The email you entered doesn't match the Microsoft 365 account used.");
            return;
          }

          const combinedData = { ...userData, tenantId: res.tenantId, country: country };
          const data = await LoginService.loginMicrosoft365(combinedData);
          data.clientState.country = country;
          data.clientState.userData = {
            name: userData.displayName,
            email: userData.mail || userData.userPrincipalName,
            jobTitle: userData.jobTitle,
            mobilePhone: userData.mobilePhone
          };

          data.clientState.success = {
            severity: 'success',
            summary: 'Success',
            detail: 'Record Already Save',
            life: 3000
          };

          data.clientState.error = {
            severity: 'error',
            summary: 'Error',
            detail: 'Error',
            life: 3000
          };

          data.clientState.warn = {
            severity: 'warn',
            summary: 'Warning',
            detail: 'Warning',
            life: 3000
          };

          data.clientState.required = {
            severity: 'warn',
            summary: 'Warning',
            detail: 'Please Check Required Field',
            life: 3000
          };

          // ✅ Fixed: stringify object storage
          sessionStorage.setItem('authToken', data.token);
          sessionStorage.setItem('refreshToken', data.refreshToken);
          localStorage.setItem('idNo', username);
          localStorage.setItem('clientState', JSON.stringify(data.clientState));
          localStorage.setItem('programRoleId', data.clientState.programRoleId);
          localStorage.setItem("365Account", JSON.stringify(userData));
          localStorage.setItem("roleRouteMappings", JSON.stringify(data.clientState.menuTree));

          navigate(`/asset/assignment/edit/${param}`);
        }
      } catch (err) {
        console.error("Redirect error:", err);
        setError(err instanceof Error ? err.message : "Login failed");
      }
    })();
  }, [navigate]);



  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  return (
    <div className="login-container" style={{backgroundColor: '#ffffffff' }}>
      <form onSubmit={handleLogin} className="login-form">
        {/* <div style={{ textAlign: 'center' }}> */}
          <img src={logo} alt="Logo" style={{ width: '350px', height: 'auto' }} />
        {/* </div> */}
        {/* <h1>{process.env.REACT_APP_SYSTEM_NAME}</h1> */}
        {error && <p className="error">{error}</p>}
        <div className="form-group">
          <input
            type="text"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Microsoft 365 Email"
            required
          />
        </div>
        <div className="form-group">
          <Button
            disabled={isLoading}
            className="login-button"
            type="submit"
            color="primary"
          >
            {isLoading ? "Logging in..." : "Login"}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default Login;
